<div class="window-slide-up app-modal-spinner" [class.on-prepare]="!isInited">

    <ng-container [ngSwitch]="currentPage">
        <ng-container *ngSwitchCase="0" [ngTemplateOutlet]="header1"> </ng-container>
        <ng-container *ngSwitchCase="1" [ngTemplateOutlet]="header2"> </ng-container>
    </ng-container>
    <div class="page-switch" [class.page-message]="currentPage==1">
        <form [formGroup]="form">
            <div class="page">
                <ng-container [ngTemplateOutlet]="page1"> </ng-container>
            </div>
            <div class="page">
                <div class="message-input">
                    <div class="warning-section">
                        <span
                            [ngClass]="[isMessageOptional ? 'optional-label' : 'require-label']">※{{isMessageOptional?'任意':'必須'}}</span>
                        <span class="require-label" *ngIf="isMessageError">メッセージを入力してください</span>
                    </div>
                    <textarea [placeholder]="'テキストを入力'" [class.error]="isMessageError"
                        formControlName="message"></textarea>
                    <span class="note-under" *ngIf="!isMessageOptional">メッセージの修正や追記が可能です。</span>
                </div>
            </div>

        </form>

    </div>

</div>


<ng-template #header1>
    <div class="header">
        <div class="close" (click)="closeModal(true)"> <mat-icon svgIcon="care-conne-close"></mat-icon></div>
        <div class="title-page">転送先</div>
        <div class="next-page" [class.disabled]="page1NextCondition()" (click)="toNextPage()">次へ{{
            selectedRoomsId.value?.length > 0 ? '('+ selectedRoomsId.value.length +')' : ''
            }}</div>
    </div>
</ng-template>
<ng-template #header2>
    <div class="header">
        <div class="close" (click)="toPrevPage()"> <mat-icon svgIcon="care-conne-back"></mat-icon></div>
        <div class="title-page">メッセージ</div>
        <div class="next-page" [class.disabled]="page2NextCondition()" (click)="submit()">送信</div>
    </div>
</ng-template>

<ng-template #page1>

    <div class="search">
        <div class="form-search">

            <div class="input-shell">
                <mat-icon svgIcon="search" class="grey"></mat-icon>
                <input [placeholder]="'検索'" [(ngModel)]="searchUser" />
                <mat-icon svgIcon="care-conne-close" class="grey" (click)="resetSearch()"></mat-icon>
            </div>
            <!--  -->
            <div class="filter-section">
                <ng-container *ngFor="let filter of filters">
                    <div class="filter-pill" [class.inactive]="!filter.isActive" (click)="filterToggle(filter)">
                        <label>{{filter.name}}</label>
                    </div>
                </ng-container>


            </div>
        </div>
    </div>
    <div class="list">
        <ng-container *ngFor="let room of rooms">
            <app-room-item [room]="room" (changeSelect)="selectRoom($event)"
                [isSelected]="isSelected(room)"></app-room-item>
        </ng-container>
        <label class="empty" *ngIf="rooms.length == 0">
            検索結果がありません
        </label>

    </div>
</ng-template>